import { Check, Minus } from "lucide-react";

export default function CompareTable({ t }) {
  if (!t.compareRows) return null;
  return (
    <section className="bg-[#0A0807] py-16 sm:py-24 border-t border-white/5" data-testid="weddings-compare">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-10">
        <div className="text-center mb-10 sm:mb-14">
          <h3 className="text-3xl sm:text-4xl lg:text-5xl text-white leading-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
            {t.compareTitle}
          </h3>
          <p className="text-sm sm:text-base text-white/55 font-light mt-3 sm:mt-4 max-w-xl mx-auto">{t.compareSubtitle}</p>
          <div className="w-12 sm:w-16 h-px bg-[#C9A87C] mx-auto mt-5 sm:mt-6" />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full min-w-[520px] sm:min-w-0 border-collapse text-left">
            <thead>
              <tr className="text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.3em] text-[#F5C77A]">
                <th className="py-4 sm:py-5 px-3 sm:px-5 font-medium border-b border-white/10"></th>
                {t.compareHeaders.map((h, i) => (
                  <th key={i} className={`py-4 sm:py-5 px-3 sm:px-5 font-medium border-b border-white/10 text-center ${i === 1 ? "text-[#F5C77A]" : "text-white/70"}`}>
                    {h.toUpperCase()}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {t.compareRows.map((r, i) => (
                <tr key={i} className={`${i % 2 === 0 ? "bg-white/[0.025]" : ""}`}>
                  <td className="py-3.5 sm:py-4 px-3 sm:px-5 text-xs sm:text-sm text-white/70 font-light border-b border-white/[0.05]">
                    {r.feature}
                  </td>
                  {r.values.map((v, j) => (
                    <td key={j}
                        className={`py-3.5 sm:py-4 px-3 sm:px-5 text-xs sm:text-sm text-center border-b border-white/[0.05] ${j === 1 ? "bg-[#F5C77A]/[0.04]" : ""}`}>
                      {v === true && <Check className="w-4 h-4 text-[#F5C77A] mx-auto" />}
                      {v === false && <Minus className="w-3.5 h-3.5 text-white/25 mx-auto" />}
                      {typeof v === "string" && (
                        <span className={`${j === 1 ? "text-white" : "text-white/80"} font-light`}>{v}</span>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
